import { CookieCategory } from "./cookie-consent.types";
import { getConsentEffect } from "./cookie-consent-registry";
import { CookiesConsent, useCookieConsentStore } from "./use-cookie-consent-store";

function applyConsentEffects(cookiesConsent: CookiesConsent, previousConsent: CookiesConsent, isFirstRun: boolean) {
  (Object.keys(cookiesConsent) as CookieCategory[]).forEach((category) => {
    const current = cookiesConsent[category];
    const previous = previousConsent[category];

    if (!isFirstRun && (current === null || current === previous)) return;

    const effect = getConsentEffect(category);
    if (!effect) return;

    if (current === true) effect.onGrant();
    else effect.onDeny();
  });
}

export function subscribeToCookieConsent() {
  const initialConsent = useCookieConsentStore.getState().cookiesConsent;
  applyConsentEffects(initialConsent, initialConsent, true);

  return useCookieConsentStore.subscribe((state, prevState) => {
    applyConsentEffects(state.cookiesConsent, prevState.cookiesConsent, false);
  });
}
